import React, { useEffect, useState } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';
import { getPriceCodeSettings, setPriceCodeSettings, validateAllLetters, priceToCode } from '../utils/priceCode';

const Profile = () => {
  const [shopName, setShopName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [address, setAddress] = useState('');
  const [printerSize, setPrinterSize] = useState('standard');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [priceCodeEnabled, setPriceCodeEnabled] = useState(false);

const [priceCodeScope, setPriceCodeScope] = useState('everything');  const [digitMap, setDigitMap] = useState({ '1': '', '2': '', '3': '', '4': '', '5': '', '6': '', '7': '', '8': '', '9': '' });
  const [zeroLetters, setZeroLetters] = useState(['', '']);
  const [repeatLetter, setRepeatLetter] = useState('');
  const [previewInput, setPreviewInput] = useState('');
  const [codePreview, setCodePreview] = useState('');
const [barcodeSize, setBarcodeSize] = useState('50x25');
const [barcodeLabelsPerRow, setBarcodeLabelsPerRow] = useState(1);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploadingLogo, setUploadingLogo] = useState(false);  const [trashItems, setTrashItems] = useState([]);
  const [loadingTrash, setLoadingTrash] = useState(false);
  useEffect(() => {
    const fetchProfile = async () => {
      setLoading(true);
      try {
        const res = await API.get('/auth/profile');
        setShopName(res.data.shop_name || '');
        setEmail(res.data.email || '');
        setPhone(res.data.phone || '');
        setWhatsapp(res.data.whatsapp || '');
        setAddress(res.data.address || '');
        setPrinterSize(res.data.printer_size || 'standard');
        setBarcodeSize(res.data.barcode_label_size || '50x25');
        setBarcodeLabelsPerRow(res.data.barcode_labels_per_row || 1);
        setLogoUrl(res.data.logo_url || '');
        localStorage.setItem('shopProfile', JSON.stringify(res.data));

        setPriceCodeEnabled(res.data.price_code_enabled || false);
        if (res.data.price_code_data) {
  setDigitMap(res.data.price_code_data.digit_map || {});
  setZeroLetters(res.data.price_code_data.zero_letters || ['', '']);
  setRepeatLetter(res.data.price_code_data.repeat_letter || '');
}
setPriceCodeScope(res.data.price_code_scope || 'everything');
        setPriceCodeSettings(
  res.data.price_code_enabled || false,
  res.data.price_code_data?.digit_map || {},
  res.data.price_code_data?.zero_letters || ['', ''],
  res.data.price_code_data?.repeat_letter || '',
  res.data.price_code_scope || 'everything'
);
      } catch (err) {
        console.error('Profile error:', err.response?.status, err.response?.data);
        if (err.response?.status === 401) {
          toast.error('Session expired. Please login again.');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/';
        } else {
          toast.error('Failed to load profile: ' + (err.response?.data?.message || err.message));
        }
      }
      setLoading(false);
    };
    fetchProfile();
  }, []);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await API.put('/auth/profile', {
        shop_name: shopName,
        phone,
        whatsapp,
        address,
        printer_size: printerSize,
        barcode_label_size: barcodeSize,
        barcode_labels_per_row: barcodeLabelsPerRow,
      });
      const user = JSON.parse(localStorage.getItem('user'));
      localStorage.setItem('user', JSON.stringify({ ...user, shop_name: res.data.shop_name }));
      localStorage.setItem('shopProfile', JSON.stringify(res.data));
      toast.success('Profile updated successfully!');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update profile');
    }
    setSaving(false);
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error('New passwords do not match!');
      return;
    }
    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters!');
      return;
    }
    try {
      await API.put('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      toast.success('Password changed successfully!');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to change password');
    }
  };

  const resizeLogoImage = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const maxWidth = 300;
          const scale = Math.min(1, maxWidth / img.width);
          const canvas = document.createElement('canvas');
          canvas.width = img.width * scale;
          canvas.height = img.height * scale;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL('image/jpeg', 0.8));
        };
        img.onerror = reject;
        img.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploadingLogo(true);
    try {
      const resized = await resizeLogoImage(file);
      const res = await API.put('/auth/logo', { logo_url: resized });
      const profile = JSON.parse(localStorage.getItem('shopProfile') || '{}');
      localStorage.setItem('shopProfile', JSON.stringify({ ...profile, logo_url: res.data.logo_url }));
      setLogoUrl(res.data.logo_url);
      toast.success('Logo uploaded! It will now appear on all your printed bills.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to upload logo');
    }
    setUploadingLogo(false);
    e.target.value = '';
  };

  const handleRemoveLogo = async () => {
    try {
      await API.put('/auth/logo', { logo_url: null });
      const profile = JSON.parse(localStorage.getItem('shopProfile') || '{}');
      localStorage.setItem('shopProfile', JSON.stringify({ ...profile, logo_url: null }));
      setLogoUrl('');
      toast.success('Logo removed');
    } catch (err) {
      toast.error('Failed to remove logo');
    }
  };

  const fetchTrash = async () => {
    setLoadingTrash(true);
    try {
      const res = await API.get('/trash');
      setTrashItems(res.data);
    } catch (err) {
      toast.error('Failed to load Trash');
    }
    setLoadingTrash(false);
  };

  const handleRestore = async (type, id) => {
    try {
      await API.put(`/trash/${type}/${id}/restore`);
      toast.success('Restored successfully!');
      fetchTrash();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to restore');
    }
  };

  const typeLabels = {
    products: '📦 Product',
    customers: '👤 Customer',
    suppliers: '🚚 Supplier',
    employees: '👷 Employee',
    expenses: '💵 Expense',
    supplier_bills: '📄 Purchase Bill',
    invoices: '🧾 Invoice',
  };

  return (
    <div>
      <Navbar />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.container} className="container">
        <h2 style={styles.title}>Shop Profile</h2>
        <div style={styles.tabs}>
          <button onClick={() => setActiveTab('profile')} style={activeTab === 'profile' ? styles.tabActive : styles.tab}>Shop Details</button>
          <button onClick={() => setActiveTab('password')} style={activeTab === 'password' ? styles.tabActive : styles.tab}>Change Password</button>
          <button onClick={() => setActiveTab('pricecode')} style={activeTab === 'pricecode' ? styles.tabActive : styles.tab}>Price Code</button>
          <button onClick={() => { setActiveTab('trash'); fetchTrash(); }} style={activeTab === 'trash' ? styles.tabActive : styles.tab}>🗑️ Trash</button>
        </div>

        {loading ? (
          <div style={styles.loaderWrapper}>
            <div style={styles.spinner}></div>
            <p style={styles.loaderText}>Loading profile...</p>
          </div>
        ) : (
          <>
            {activeTab === 'profile' && (
              <div style={styles.card}>
                <form onSubmit={handleUpdateProfile}>
                  <div style={styles.field}>
                    <label style={styles.label}>🖼️ Shop Logo</label>
                    {logoUrl && (
                      <div style={{ marginBottom: '0.75rem' }}>
                        <img src={logoUrl} alt="Shop logo" style={{ maxWidth: '150px', maxHeight: '80px', display: 'block', marginBottom: '0.5rem', border: '1px solid #ddd', borderRadius: '6px', padding: '4px' }} />
                        <button type="button" onClick={handleRemoveLogo} style={{ padding: '6px 12px', background: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                          Remove Logo
                        </button>
                      </div>
                    )}
                    <input type="file" accept="image/*" onChange={handleLogoUpload} disabled={uploadingLogo} />
                    <p style={styles.hint}>{uploadingLogo ? 'Uploading...' : 'Upload your shop logo — it will appear next to your shop name on every printed bill'}</p>
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>Shop Name</label>
                    <input style={styles.input} type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} required />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>Email</label>
                    <input style={{ ...styles.input, background: '#f5f5f5' }} type="email" value={email} disabled />
                    <p style={styles.hint}>Email cannot be changed</p>
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>📞 Phone Number</label>
                    <input style={styles.input} type="text" placeholder="076 123 4567" value={phone} onChange={(e) => setPhone(e.target.value)} />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>💬 WhatsApp Number</label>
                    <input style={styles.input} type="text" placeholder="076 123 4567" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>📍 Shop Address</label>
                    <textarea style={styles.textarea} placeholder="No. 123, Main Street, Colombo" value={address} onChange={(e) => setAddress(e.target.value)} rows={3} />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>🖨️ Receipt Printer Size</label>
                    <select style={styles.input} value={printerSize} onChange={(e) => setPrinterSize(e.target.value)}>
                      <option value="standard">Standard (A4 / Browser Print)</option>
                      <option value="57mm">57mm Thermal Roll (2 inch)</option>
                      <option value="79mm">79mm Thermal Roll (3 inch)</option>
                    </select>
                    <p style={styles.hint}>Select your thermal printer roll size for perfectly formatted receipts</p>
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>🏷️ Barcode Label Roll Size</label>
                    <select style={styles.input} value={barcodeSize} onChange={(e) => setBarcodeSize(e.target.value)}>
                      <option value="50x25">50mm x 25mm (Standard)</option>
                      <option value="40x30">40mm x 30mm</option>
                      <option value="30x20">30mm x 20mm (Small)</option>
                    </select>
                    <p style={styles.hint}>Select your barcode sticker roll size for continuous printing</p>
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>🏷️ Labels Side-by-Side on Roll</label>
                    <select style={styles.input} value={barcodeLabelsPerRow} onChange={(e) => setBarcodeLabelsPerRow(parseInt(e.target.value))}>
                      <option value="1">1 (single column)</option>
                      <option value="2">2 (2-up)</option>
                      <option value="3">3 (3-up)</option>
                    </select>
                    <p style={styles.hint}>How many labels sit side-by-side on your barcode printer's roll</p>
                  </div>
                  <button style={styles.button} type="submit" disabled={saving}>
                    {saving ? 'Saving...' : 'Save Changes'}
                  </button>
                </form>
              </div>
            )}

            {activeTab === 'password' && (
              <div style={styles.card}>
                <form onSubmit={handleChangePassword}>
                  <div style={styles.field}>
                    <label style={styles.label}>Current Password</label>
                    <input style={styles.input} type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} required />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>New Password</label>
                    <input style={styles.input} type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required />
                  </div>
                  <div style={styles.field}>
                    <label style={styles.label}>Confirm New Password</label>
                    <input style={styles.input} type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                  </div>
                  <button style={styles.button} type="submit">Change Password</button>
                </form>
              </div>
            )}

            {activeTab === 'pricecode' && (
              <div style={styles.card}>
                <h3 style={{ marginBottom: '1rem', fontSize: '16px' }}>🔐 Price Code System</h3>
                <p style={{ fontSize: '14px', color: '#888', marginBottom: '1.5rem' }}>
                  Hide your buying price from customers and staff using your own secret letter code.
                  You need to set 12 unique letters total.
                </p>

                <div style={styles.field}>
                  <label style={styles.label}>Enable Price Code System</label>
                  <div style={{ display: 'flex', gap: '1rem' }}>
                    <button
                      onClick={() => setPriceCodeEnabled(true)}
                      style={priceCodeEnabled ? styles.button : { ...styles.button, background: '#ddd', color: '#555' }}
                      type="button"
                    >
                      Enable
                    </button>
                    <button
                      onClick={() => setPriceCodeEnabled(false)}
                      style={!priceCodeEnabled ? styles.button : { ...styles.button, background: '#ddd', color: '#555' }}
                      type="button"
                    >
                      Disable
                    </button>
                  </div>
                </div>

                {priceCodeEnabled && (
                  <>
                    <div style={styles.field}>
                      <label style={styles.label}>Letters for digits 1 to 9 (one letter each)</label>
                      <div style={styles.digitGrid}>
                        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
                          <div key={d} style={styles.digitInputWrap}>
                            <span style={styles.digitLabel}>{d}</span>
                            <input
                              style={styles.digitInput}
                              type="text"
                              maxLength={1}
                              value={digitMap[d] || ''}
                              onChange={(e) => setDigitMap({ ...digitMap, [d]: e.target.value.toUpperCase() })}
                            />
                          </div>
                        ))}
                      </div>
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>Two letters for digit 0 (used alternately)</label>
                      <div style={styles.digitGrid}>
                        <div style={styles.digitInputWrap}>
                          <span style={styles.digitLabel}>0 (1st)</span>
                          <input
                            style={styles.digitInput}
                            type="text"
                            maxLength={1}
                            value={zeroLetters[0] || ''}
                            onChange={(e) => setZeroLetters([e.target.value.toUpperCase(), zeroLetters[1]])}
                          />
                        </div>
                        <div style={styles.digitInputWrap}>
                          <span style={styles.digitLabel}>0 (2nd)</span>
                          <input
                            style={styles.digitInput}
                            type="text"
                            maxLength={1}
                            value={zeroLetters[1] || ''}
                            onChange={(e) => setZeroLetters([zeroLetters[0], e.target.value.toUpperCase()])}
                          />
                        </div>
                      </div>
                    </div>

                    <div style={styles.field}>
                      <label style={styles.label}>Repeat letter (used when a digit 1-9 repeats back to back)</label>
                      <input
                        style={{ ...styles.digitInput, width: '60px' }}
                        type="text"
                        maxLength={1}
                        value={repeatLetter}
                        onChange={(e) => setRepeatLetter(e.target.value.toUpperCase())}
                      />
                      <p style={{ fontSize: '12px', color: '#888', marginTop: '4px' }}>
                        Example: if your letter for 1 is "A" and repeat letter is "K", then 1100 with 0-letters X,Y becomes A K X Y
                      </p>
                    </div>
                    <div style={styles.field}>
  <label style={styles.label}>Apply price code to:</label>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', marginTop: '0.5rem' }}>
    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
      <input
        type="radio"
        value="everything"
        checked={priceCodeScope === 'everything'}
        onChange={() => setPriceCodeScope('everything')}
      />
      <div>
        <strong>Everything</strong>
        <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>Hide buying price on screen, invoice and barcode sticker</p>
      </div>
    </label>
    <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer' }}>
      <input
        type="radio"
        value="barcode_only"
        checked={priceCodeScope === 'barcode_only'}
        onChange={() => setPriceCodeScope('barcode_only')}
      />
      <div>
        <strong>Barcode sticker only</strong>
        <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>Show normal prices on screen, hide only on barcode sticker</p>
      </div>
    </label>
  </div>
</div>

                    <div style={styles.field}>
                      <label style={styles.label}>Test your code — enter a price to preview:</label>
                      <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                        <input
                          style={{ ...styles.input, maxWidth: '150px', marginBottom: 0 }}
                          type="number"
                          placeholder="e.g. 1100"
                          value={previewInput}
                          onChange={(e) => {
                            setPreviewInput(e.target.value);
                            if (e.target.value && validateAllLetters(digitMap, zeroLetters, repeatLetter)) {
                              setPriceCodeSettings(true, digitMap, zeroLetters, repeatLetter);
                              setCodePreview(priceToCode(e.target.value));
                            } else {
                              setCodePreview('');
                            }
                          }}
                        />
                        {codePreview && (
                          <div style={styles.previewBox}>
                            <span style={styles.previewCode}>{codePreview}</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      style={styles.button}
                      type="button"
                      onClick={async () => {
                        if (!validateAllLetters(digitMap, zeroLetters, repeatLetter)) {
                          toast.error('Please fill all 12 letters with unique values!');
                          return;
                        }
                        try {
                          await API.put('/auth/price-code', {
  price_code_enabled: true,
  digit_map: digitMap,
  zero_letters: zeroLetters,
  repeat_letter: repeatLetter,
  scope: priceCodeScope,
});
setPriceCodeSettings(true, digitMap, zeroLetters, repeatLetter, priceCodeScope);
                          toast.success('Price code saved successfully!');
                        } catch (err) {
                          toast.error(err.response?.data?.message || 'Failed to save price code');
                        }
                      }}
                    >
                      Save Price Code
                    </button>
                  </>
                )}

                {!priceCodeEnabled && (
                  <button
                    style={styles.button}
                    type="button"
                    onClick={async () => {
                      try {
                        await API.put('/auth/price-code', { price_code_enabled: false });
                        setPriceCodeSettings(false, {}, ['', ''], '');
                        toast.success('Price code disabled!');
                      } catch (err) {
                        toast.error('Failed to update settings');
                      }
                    }}
                  >
                    Save Settings
                  </button>
                )}
              </div>
            )}

            {activeTab === 'trash' && (
              <div style={styles.card}>
                <p style={{ fontSize: '13px', color: '#888', marginBottom: '1rem' }}>
                  Deleted items stay here for 30 days before being permanently removed. Click Restore to bring something back.
                </p>
                {loadingTrash ? (
                  <p style={{ color: '#888', fontSize: '14px' }}>Loading...</p>
                ) : trashItems.length === 0 ? (
                  <p style={{ color: '#888', fontSize: '14px' }}>Trash is empty</p>
                ) : (
                  trashItems.map((item) => (
                    <div key={`${item.type}-${item.id}`} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 14px', background: '#f9f9ff', borderRadius: '8px', marginBottom: '8px' }}>
                      <div>
                        <p style={{ fontSize: '14px', fontWeight: '600', margin: 0 }}>{typeLabels[item.type]}: {item.name}</p>
                        <p style={{ fontSize: '12px', color: '#888', margin: 0 }}>Deleted {new Date(item.deleted_at).toLocaleDateString()}</p>
                      </div>
                      <button onClick={() => handleRestore(item.type, item.id)} style={{ padding: '6px 14px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
                        Restore
                      </button>
                    </div>
                  ))
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem', maxWidth: '600px', margin: '0 auto' },
  title: { fontSize: '24px', marginBottom: '1.5rem' },
  tabs: { display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' },
  tab: { flex: 1, padding: '10px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tabActive: { flex: 1, padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  card: { background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  field: { marginBottom: '1.25rem' },
  label: { display: 'block', fontSize: '14px', fontWeight: '500', marginBottom: '6px', color: '#444' },
  input: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  textarea: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' },
  hint: { fontSize: '12px', color: '#888', marginTop: '4px' },
  button: { width: '100%', padding: '12px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
  loaderWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4rem' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  loaderText: { marginTop: '1rem', color: '#888', fontSize: '14px' },
  digitGrid: { display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '0.5rem' },
  digitInputWrap: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' },
  digitLabel: { fontSize: '12px', color: '#888', fontWeight: '500' },
  digitInput: { width: '44px', height: '44px', textAlign: 'center', borderRadius: '8px', border: '1px solid #ddd', fontSize: '18px', fontWeight: 'bold', textTransform: 'uppercase' },
  previewBox: { background: '#f5f3ff', padding: '8px 16px', borderRadius: '8px' },
  previewCode: { fontSize: '20px', fontWeight: 'bold', color: '#4f46e5', letterSpacing: '3px' },
};

export default Profile;